import React from 'react';

const MarkAsPaid = ({ style }: any) => (
  <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.5" width="14" height="14" rx="7" fill={style.fill || '#667085'} fillOpacity="0.1" />
    <path d="M4.08203 7.71875L6.05161 9.6875L9.98911 5.75" stroke={style?.path || '#667085'} strokeWidth="0.875" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default MarkAsPaid;
